import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { ConsumerEntityState } from './consumer.entity.reducer';
import { consumerEntitySelectorKey } from './consumer.entity.reducer';

export const consumerEntityState = createFeatureSelector<ConsumerEntityState>(
  consumerEntitySelectorKey
);

export const selectHasMultiAccount = createSelector(
  consumerEntityState,
  (state) => (state.getOnlineAccount.data?.customers?.length ?? 0) > 1
);
